import React, { memo } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const ClockIcon = ({ fill, ...rest }: SvgIconProps) => (
  <SvgIcon width={40} height={40} {...rest} viewBox="0 0 40 40">
    <path
      d="M18 0.0987524C7.89337 1.10223 0 9.62932 0 20C0 31.0457 8.95436 40 20.0001 40C31.0458 40 40 31.0457 40 20C40 9.62929 32.1067 1.10216 22 0.0987396V4.12378C29.8927 5.10794 36 11.8407 36 20C36 28.8366 28.8366 36 20.0001 36C11.1635 36 4 28.8365 4 20C4 11.8408 10.1074 5.10801 18 4.12379V0.0987524Z"
      fill={fill}
    />
    <path d="M18 10V21.5684L26.6964 26.7413L28.7413 23.3036L22 19.2936V10H18Z" fill={fill} />
  </SvgIcon>
);

export default memo(ClockIcon);
